/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Api
 * ISM | New World W3 Metaverse Platform API
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  Avatar,
  Creator,
  Event,
  EventInput,
  GasFeeRecord,
  GetFeaturedMembersContentParams,
  HealthStatus,
  LikeResult,
  ListAvatarsParams,
  ListCreatorsParams,
  ListEventsParams,
  ListGasFeesParams,
  ListMembersContentParams,
  ListProductsParams,
  ListSpacesParams,
  MembersContent,
  MembersContentInput,
  MembersRates,
  OmSyncResult,
  PlatformStats,
  Product,
  ProductInput,
  ProductPatch,
  Region,
  Space
} from './api.schemas';

import { customFetch } from '../custom-fetch';
import type { ErrorType , BodyType } from '../custom-fetch';

type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export const getHealthCheckUrl = () => {




  return `/api/healthz`
}

/**
 * Returns server health status
 * @summary Health check
 */
export const healthCheck = async ( options?: RequestInit): Promise<HealthStatus> => {

  return customFetch<HealthStatus>(getHealthCheckUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getHealthCheckQueryKey = () => {
    return [
    `/api/healthz`
    ] as const;
    }


export const getHealthCheckQueryOptions = <TData = Awaited<ReturnType<typeof healthCheck>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHealthCheckQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof healthCheck>>> = ({ signal }) => healthCheck({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData> & { queryKey: QueryKey }
}

export type HealthCheckQueryResult = NonNullable<Awaited<ReturnType<typeof healthCheck>>>
export type HealthCheckQueryError = ErrorType<unknown>


/**
 * @summary Health check
 */

export function useHealthCheck<TData = Awaited<ReturnType<typeof healthCheck>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getHealthCheckQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getListSpacesUrl = (params?: ListSpacesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/spaces?${stringifiedParams}` : `/api/spaces`
}

/**
 * @summary List all virtual spaces
 */
export const listSpaces = async (params?: ListSpacesParams, options?: RequestInit): Promise<Space[]> => {

  return customFetch<Space[]>(getListSpacesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListSpacesQueryKey = (params?: ListSpacesParams,) => {
    return [
    `/api/spaces`, ...(params ? [params] : [])
    ] as const;
    }


export const getListSpacesQueryOptions = <TData = Awaited<ReturnType<typeof listSpaces>>, TError = ErrorType<unknown>>(params?: ListSpacesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listSpaces>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListSpacesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listSpaces>>> = ({ signal }) => listSpaces(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listSpaces>>, TError, TData> & { queryKey: QueryKey }
}

export type ListSpacesQueryResult = NonNullable<Awaited<ReturnType<typeof listSpaces>>>
export type ListSpacesQueryError = ErrorType<unknown>


/**
 * @summary List all virtual spaces
 */

export function useListSpaces<TData = Awaited<ReturnType<typeof listSpaces>>, TError = ErrorType<unknown>>(
 params?: ListSpacesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listSpaces>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListSpacesQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getGetFeaturedSpacesUrl = () => {




  return `/api/spaces/featured`
}

/**
 * @summary Get featured/spotlight spaces
 */
export const getFeaturedSpaces = async ( options?: RequestInit): Promise<Space[]> => {

  return customFetch<Space[]>(getGetFeaturedSpacesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetFeaturedSpacesQueryKey = () => {
    return [
    `/api/spaces/featured`
    ] as const;
    }


export const getGetFeaturedSpacesQueryOptions = <TData = Awaited<ReturnType<typeof getFeaturedSpaces>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getFeaturedSpaces>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetFeaturedSpacesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getFeaturedSpaces>>> = ({ signal }) => getFeaturedSpaces({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getFeaturedSpaces>>, TError, TData> & { queryKey: QueryKey }
}

export type GetFeaturedSpacesQueryResult = NonNullable<Awaited<ReturnType<typeof getFeaturedSpaces>>>
export type GetFeaturedSpacesQueryError = ErrorType<unknown>


/**
 * @summary Get featured/spotlight spaces
 */

export function useGetFeaturedSpaces<TData = Awaited<ReturnType<typeof getFeaturedSpaces>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getFeaturedSpaces>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetFeaturedSpacesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getGetSpaceUrl = (id: number,) => {




  return `/api/spaces/${id}`
}

/**
 * @summary Get a specific space
 */
export const getSpace = async (id: number, options?: RequestInit): Promise<Space> => {

  return customFetch<Space>(getGetSpaceUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetSpaceQueryKey = (id: number,) => {
    return [
    `/api/spaces/${id}`
    ] as const;
    }


export const getGetSpaceQueryOptions = <TData = Awaited<ReturnType<typeof getSpace>>, TError = ErrorType<void>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSpace>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSpaceQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSpace>>> = ({ signal }) => getSpace(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSpace>>, TError, TData> & { queryKey: QueryKey }
}

export type GetSpaceQueryResult = NonNullable<Awaited<ReturnType<typeof getSpace>>>
export type GetSpaceQueryError = ErrorType<void>


/**
 * @summary Get a specific space
 */

export function useGetSpace<TData = Awaited<ReturnType<typeof getSpace>>, TError = ErrorType<void>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSpace>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetSpaceQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getListAvatarsUrl = (params?: ListAvatarsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/avatars?${stringifiedParams}` : `/api/avatars`
}

/**
 * @summary List available avatars
 */
export const listAvatars = async (params?: ListAvatarsParams, options?: RequestInit): Promise<Avatar[]> => {

  return customFetch<Avatar[]>(getListAvatarsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAvatarsQueryKey = (params?: ListAvatarsParams,) => {
    return [
    `/api/avatars`, ...(params ? [params] : [])
    ] as const;
    }


export const getListAvatarsQueryOptions = <TData = Awaited<ReturnType<typeof listAvatars>>, TError = ErrorType<unknown>>(params?: ListAvatarsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAvatars>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAvatarsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAvatars>>> = ({ signal }) => listAvatars(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAvatars>>, TError, TData> & { queryKey: QueryKey }
}

export type ListAvatarsQueryResult = NonNullable<Awaited<ReturnType<typeof listAvatars>>>
export type ListAvatarsQueryError = ErrorType<unknown>


/**
 * @summary List available avatars
 */

export function useListAvatars<TData = Awaited<ReturnType<typeof listAvatars>>, TError = ErrorType<unknown>>(
 params?: ListAvatarsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAvatars>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListAvatarsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getGetAvatarUrl = (id: number,) => {




  return `/api/avatars/${id}`
}

/**
 * @summary Get avatar details
 */
export const getAvatar = async (id: number, options?: RequestInit): Promise<Avatar> => {

  return customFetch<Avatar>(getGetAvatarUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAvatarQueryKey = (id: number,) => {
    return [
    `/api/avatars/${id}`
    ] as const;
    }


export const getGetAvatarQueryOptions = <TData = Awaited<ReturnType<typeof getAvatar>>, TError = ErrorType<void>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAvatar>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAvatarQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAvatar>>> = ({ signal }) => getAvatar(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAvatar>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAvatarQueryResult = NonNullable<Awaited<ReturnType<typeof getAvatar>>>
export type GetAvatarQueryError = ErrorType<void>


/**
 * @summary Get avatar details
 */

export function useGetAvatar<TData = Awaited<ReturnType<typeof getAvatar>>, TError = ErrorType<void>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAvatar>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAvatarQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getListProductsUrl = (params?: ListProductsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/products?${stringifiedParams}` : `/api/products`
}

/**
 * @summary List marketplace products
 */
export const listProducts = async (params?: ListProductsParams, options?: RequestInit): Promise<Product[]> => {

  return customFetch<Product[]>(getListProductsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListProductsQueryKey = (params?: ListProductsParams,) => {
    return [
    `/api/products`, ...(params ? [params] : [])
    ] as const;
    }


export const getListProductsQueryOptions = <TData = Awaited<ReturnType<typeof listProducts>>, TError = ErrorType<unknown>>(params?: ListProductsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listProducts>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListProductsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listProducts>>> = ({ signal }) => listProducts(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listProducts>>, TError, TData> & { queryKey: QueryKey }
}

export type ListProductsQueryResult = NonNullable<Awaited<ReturnType<typeof listProducts>>>
export type ListProductsQueryError = ErrorType<unknown>


/**
 * @summary List marketplace products
 */

export function useListProducts<TData = Awaited<ReturnType<typeof listProducts>>, TError = ErrorType<unknown>>(
 params?: ListProductsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listProducts>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListProductsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateProductUrl = () => {




  return `/api/products`
}

/**
 * @summary Create/list a new product
 */
export const createProduct = async (productInput: ProductInput, options?: RequestInit): Promise<Product> => {

  return customFetch<Product>(getCreateProductUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      productInput,)
  }
);}




export const getCreateProductMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createProduct>>, TError,{data: BodyType<ProductInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createProduct>>, TError,{data: BodyType<ProductInput>}, TContext> => {

const mutationKey = ['createProduct'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createProduct>>, {data: BodyType<ProductInput>}> = (props) => {
          const {data} = props ?? {};

          return  createProduct(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateProductMutationResult = NonNullable<Awaited<ReturnType<typeof createProduct>>>
    export type CreateProductMutationBody = BodyType<ProductInput>
    export type CreateProductMutationError = ErrorType<unknown>

    /**
 * @summary Create/list a new product
 */
export const useCreateProduct = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createProduct>>, TError,{data: BodyType<ProductInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createProduct>>,
        TError,
        {data: BodyType<ProductInput>},
        TContext
      > => {
      return useMutation(getCreateProductMutationOptions(options));
    }

export const getGetFeaturedProductsUrl = () => {




  return `/api/products/featured`
}

/**
 * @summary Get featured/trending marketplace products
 */
export const getFeaturedProducts = async ( options?: RequestInit): Promise<Product[]> => {

  return customFetch<Product[]>(getGetFeaturedProductsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetFeaturedProductsQueryKey = () => {
    return [
    `/api/products/featured`
    ] as const;
    }


export const getGetFeaturedProductsQueryOptions = <TData = Awaited<ReturnType<typeof getFeaturedProducts>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getFeaturedProducts>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetFeaturedProductsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getFeaturedProducts>>> = ({ signal }) => getFeaturedProducts({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getFeaturedProducts>>, TError, TData> & { queryKey: QueryKey }
}

export type GetFeaturedProductsQueryResult = NonNullable<Awaited<ReturnType<typeof getFeaturedProducts>>>
export type GetFeaturedProductsQueryError = ErrorType<unknown>


/**
 * @summary Get featured/trending marketplace products
 */

export function useGetFeaturedProducts<TData = Awaited<ReturnType<typeof getFeaturedProducts>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getFeaturedProducts>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetFeaturedProductsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getGetProductUrl = (id: number,) => {




  return `/api/products/${id}`
}

/**
 * @summary Get product details
 */
export const getProduct = async (id: number, options?: RequestInit): Promise<Product> => {

  return customFetch<Product>(getGetProductUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetProductQueryKey = (id: number,) => {
    return [
    `/api/products/${id}`
    ] as const;
    }


export const getGetProductQueryOptions = <TData = Awaited<ReturnType<typeof getProduct>>, TError = ErrorType<void>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getProduct>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProductQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProduct>>> = ({ signal }) => getProduct(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getProduct>>, TError, TData> & { queryKey: QueryKey }
}

export type GetProductQueryResult = NonNullable<Awaited<ReturnType<typeof getProduct>>>
export type GetProductQueryError = ErrorType<void>


/**
 * @summary Get product details
 */

export function useGetProduct<TData = Awaited<ReturnType<typeof getProduct>>, TError = ErrorType<void>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getProduct>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetProductQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getUpdateProductUrl = (id: number,) => {




  return `/api/products/${id}`
}

/**
 * @summary Update a product listing
 */
export const updateProduct = async (id: number,
    productPatch: ProductPatch, options?: RequestInit): Promise<Product> => {

  return customFetch<Product>(getUpdateProductUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      productPatch,)
  }
);}




export const getUpdateProductMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateProduct>>, TError,{id: number;data: BodyType<ProductPatch>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateProduct>>, TError,{id: number;data: BodyType<ProductPatch>}, TContext> => {

const mutationKey = ['updateProduct'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateProduct>>, {id: number;data: BodyType<ProductPatch>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateProduct(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateProductMutationResult = NonNullable<Awaited<ReturnType<typeof updateProduct>>>
    export type UpdateProductMutationBody = BodyType<ProductPatch>
    export type UpdateProductMutationError = ErrorType<unknown>

    /**
 * @summary Update a product listing
 */
export const useUpdateProduct = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateProduct>>, TError,{id: number;data: BodyType<ProductPatch>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateProduct>>,
        TError,
        {id: number;data: BodyType<ProductPatch>},
        TContext
      > => {
      return useMutation(getUpdateProductMutationOptions(options));
    }

export const getListEventsUrl = (params?: ListEventsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/events?${stringifiedParams}` : `/api/events`
}

/**
 * @summary List virtual events
 */
export const listEvents = async (params?: ListEventsParams, options?: RequestInit): Promise<Event[]> => {

  return customFetch<Event[]>(getListEventsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListEventsQueryKey = (params?: ListEventsParams,) => {
    return [
    `/api/events`, ...(params ? [params] : [])
    ] as const;
    }


export const getListEventsQueryOptions = <TData = Awaited<ReturnType<typeof listEvents>>, TError = ErrorType<unknown>>(params?: ListEventsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listEvents>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListEventsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listEvents>>> = ({ signal }) => listEvents(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listEvents>>, TError, TData> & { queryKey: QueryKey }
}

export type ListEventsQueryResult = NonNullable<Awaited<ReturnType<typeof listEvents>>>
export type ListEventsQueryError = ErrorType<unknown>


/**
 * @summary List virtual events
 */

export function useListEvents<TData = Awaited<ReturnType<typeof listEvents>>, TError = ErrorType<unknown>>(
 params?: ListEventsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listEvents>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListEventsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateEventUrl = () => {




  return `/api/events`
}

/**
 * @summary Create a new event
 */
export const createEvent = async (eventInput: EventInput, options?: RequestInit): Promise<Event> => {

  return customFetch<Event>(getCreateEventUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      eventInput,)
  }
);}




export const getCreateEventMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createEvent>>, TError,{data: BodyType<EventInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createEvent>>, TError,{data: BodyType<EventInput>}, TContext> => {

const mutationKey = ['createEvent'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createEvent>>, {data: BodyType<EventInput>}> = (props) => {
          const {data} = props ?? {};

          return  createEvent(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateEventMutationResult = NonNullable<Awaited<ReturnType<typeof createEvent>>>
    export type CreateEventMutationBody = BodyType<EventInput>
    export type CreateEventMutationError = ErrorType<unknown>

    /**
 * @summary Create a new event
 */
export const useCreateEvent = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createEvent>>, TError,{data: BodyType<EventInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createEvent>>,
        TError,
        {data: BodyType<EventInput>},
        TContext
      > => {
      return useMutation(getCreateEventMutationOptions(options));
    }

export const getGetEventUrl = (id: number,) => {




  return `/api/events/${id}`
}

/**
 * @summary Get event details
 */
export const getEvent = async (id: number, options?: RequestInit): Promise<Event> => {

  return customFetch<Event>(getGetEventUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetEventQueryKey = (id: number,) => {
    return [
    `/api/events/${id}`
    ] as const;
    }


export const getGetEventQueryOptions = <TData = Awaited<ReturnType<typeof getEvent>>, TError = ErrorType<void>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getEvent>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEventQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEvent>>> = ({ signal }) => getEvent(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEvent>>, TError, TData> & { queryKey: QueryKey }
}

export type GetEventQueryResult = NonNullable<Awaited<ReturnType<typeof getEvent>>>
export type GetEventQueryError = ErrorType<void>


/**
 * @summary Get event details
 */

export function useGetEvent<TData = Awaited<ReturnType<typeof getEvent>>, TError = ErrorType<void>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getEvent>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetEventQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getGetPlatformStatsUrl = () => {




  return `/api/platform/stats`
}

/**
 * @summary Get platform-wide statistics
 */
export const getPlatformStats = async ( options?: RequestInit): Promise<PlatformStats> => {

  return customFetch<PlatformStats>(getGetPlatformStatsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPlatformStatsQueryKey = () => {
    return [
    `/api/platform/stats`
    ] as const;
    }


export const getGetPlatformStatsQueryOptions = <TData = Awaited<ReturnType<typeof getPlatformStats>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPlatformStats>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPlatformStatsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPlatformStats>>> = ({ signal }) => getPlatformStats({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPlatformStats>>, TError, TData> & { queryKey: QueryKey }
}

export type GetPlatformStatsQueryResult = NonNullable<Awaited<ReturnType<typeof getPlatformStats>>>
export type GetPlatformStatsQueryError = ErrorType<unknown>


/**
 * @summary Get platform-wide statistics
 */

export function useGetPlatformStats<TData = Awaited<ReturnType<typeof getPlatformStats>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPlatformStats>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetPlatformStatsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getListRegionsUrl = () => {




  return `/api/platform/regions`
}

/**
 * @summary List all world regions with space counts
 */
export const listRegions = async ( options?: RequestInit): Promise<Region[]> => {

  return customFetch<Region[]>(getListRegionsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListRegionsQueryKey = () => {
    return [
    `/api/platform/regions`
    ] as const;
    }


export const getListRegionsQueryOptions = <TData = Awaited<ReturnType<typeof listRegions>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listRegions>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListRegionsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listRegions>>> = ({ signal }) => listRegions({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listRegions>>, TError, TData> & { queryKey: QueryKey }
}

export type ListRegionsQueryResult = NonNullable<Awaited<ReturnType<typeof listRegions>>>
export type ListRegionsQueryError = ErrorType<unknown>


/**
 * @summary List all world regions with space counts
 */

export function useListRegions<TData = Awaited<ReturnType<typeof listRegions>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listRegions>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListRegionsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getListCreatorsUrl = (params?: ListCreatorsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/members/creators?${stringifiedParams}` : `/api/members/creators`
}

/**
 * @summary List Only-Memberz creators
 */
export const listCreators = async (params?: ListCreatorsParams, options?: RequestInit): Promise<Creator[]> => {

  return customFetch<Creator[]>(getListCreatorsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListCreatorsQueryKey = (params?: ListCreatorsParams,) => {
    return [
    `/api/members/creators`, ...(params ? [params] : [])
    ] as const;
    }


export const getListCreatorsQueryOptions = <TData = Awaited<ReturnType<typeof listCreators>>, TError = ErrorType<unknown>>(params?: ListCreatorsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listCreators>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListCreatorsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listCreators>>> = ({ signal }) => listCreators(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listCreators>>, TError, TData> & { queryKey: QueryKey }
}

export type ListCreatorsQueryResult = NonNullable<Awaited<ReturnType<typeof listCreators>>>
export type ListCreatorsQueryError = ErrorType<unknown>


/**
 * @summary List Only-Memberz creators
 */

export function useListCreators<TData = Awaited<ReturnType<typeof listCreators>>, TError = ErrorType<unknown>>(
 params?: ListCreatorsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listCreators>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListCreatorsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getGetCreatorUrl = (id: number,) => {




  return `/api/members/creators/${id}`
}

/**
 * @summary Get creator profile
 */
export const getCreator = async (id: number, options?: RequestInit): Promise<Creator> => {

  return customFetch<Creator>(getGetCreatorUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetCreatorQueryKey = (id: number,) => {
    return [
    `/api/members/creators/${id}`
    ] as const;
    }


export const getGetCreatorQueryOptions = <TData = Awaited<ReturnType<typeof getCreator>>, TError = ErrorType<void>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCreator>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCreatorQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCreator>>> = ({ signal }) => getCreator(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCreator>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCreatorQueryResult = NonNullable<Awaited<ReturnType<typeof getCreator>>>
export type GetCreatorQueryError = ErrorType<void>


/**
 * @summary Get creator profile
 */

export function useGetCreator<TData = Awaited<ReturnType<typeof getCreator>>, TError = ErrorType<void>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCreator>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetCreatorQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getListMembersContentUrl = (params?: ListMembersContentParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/members/content?${stringifiedParams}` : `/api/members/content`
}

/**
 * @summary List creator content items
 */
export const listMembersContent = async (params?: ListMembersContentParams, options?: RequestInit): Promise<MembersContent[]> => {

  return customFetch<MembersContent[]>(getListMembersContentUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListMembersContentQueryKey = (params?: ListMembersContentParams,) => {
    return [
    `/api/members/content`, ...(params ? [params] : [])
    ] as const;
    }


export const getListMembersContentQueryOptions = <TData = Awaited<ReturnType<typeof listMembersContent>>, TError = ErrorType<unknown>>(params?: ListMembersContentParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listMembersContent>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListMembersContentQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listMembersContent>>> = ({ signal }) => listMembersContent(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listMembersContent>>, TError, TData> & { queryKey: QueryKey }
}

export type ListMembersContentQueryResult = NonNullable<Awaited<ReturnType<typeof listMembersContent>>>
export type ListMembersContentQueryError = ErrorType<unknown>


/**
 * @summary List creator content items
 */

export function useListMembersContent<TData = Awaited<ReturnType<typeof listMembersContent>>, TError = ErrorType<unknown>>(
 params?: ListMembersContentParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listMembersContent>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListMembersContentQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateMembersContentUrl = () => {




  return `/api/members/content`
}

/**
 * @summary Upload new content — charges GLO gas fee to requester
 */
export const createMembersContent = async (membersContentInput: MembersContentInput, options?: RequestInit): Promise<MembersContent> => {

  return customFetch<MembersContent>(getCreateMembersContentUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      membersContentInput,)
  }
);}




export const getCreateMembersContentMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createMembersContent>>, TError,{data: BodyType<MembersContentInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createMembersContent>>, TError,{data: BodyType<MembersContentInput>}, TContext> => {

const mutationKey = ['createMembersContent'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createMembersContent>>, {data: BodyType<MembersContentInput>}> = (props) => {
          const {data} = props ?? {};

          return  createMembersContent(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateMembersContentMutationResult = NonNullable<Awaited<ReturnType<typeof createMembersContent>>>
    export type CreateMembersContentMutationBody = BodyType<MembersContentInput>
    export type CreateMembersContentMutationError = ErrorType<unknown>

    /**
 * @summary Upload new content — charges GLO gas fee to requester
 */
export const useCreateMembersContent = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createMembersContent>>, TError,{data: BodyType<MembersContentInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createMembersContent>>,
        TError,
        {data: BodyType<MembersContentInput>},
        TContext
      > => {
      return useMutation(getCreateMembersContentMutationOptions(options));
    }

export const getGetFeaturedMembersContentUrl = (params?: GetFeaturedMembersContentParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/members/content/featured?${stringifiedParams}` : `/api/members/content/featured`
}

/**
 * @summary Get featured/trending content
 */
export const getFeaturedMembersContent = async (params?: GetFeaturedMembersContentParams, options?: RequestInit): Promise<MembersContent[]> => {

  return customFetch<MembersContent[]>(getGetFeaturedMembersContentUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetFeaturedMembersContentQueryKey = (params?: GetFeaturedMembersContentParams,) => {
    return [
    `/api/members/content/featured`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetFeaturedMembersContentQueryOptions = <TData = Awaited<ReturnType<typeof getFeaturedMembersContent>>, TError = ErrorType<unknown>>(params?: GetFeaturedMembersContentParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getFeaturedMembersContent>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetFeaturedMembersContentQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getFeaturedMembersContent>>> = ({ signal }) => getFeaturedMembersContent(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getFeaturedMembersContent>>, TError, TData> & { queryKey: QueryKey }
}

export type GetFeaturedMembersContentQueryResult = NonNullable<Awaited<ReturnType<typeof getFeaturedMembersContent>>>
export type GetFeaturedMembersContentQueryError = ErrorType<unknown>


/**
 * @summary Get featured/trending content
 */

export function useGetFeaturedMembersContent<TData = Awaited<ReturnType<typeof getFeaturedMembersContent>>, TError = ErrorType<unknown>>(
 params?: GetFeaturedMembersContentParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getFeaturedMembersContent>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetFeaturedMembersContentQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getGetMembersContentUrl = (id: number,) => {




  return `/api/members/content/${id}`
}

/**
 * @summary Get a single content item
 */
export const getMembersContent = async (id: number, options?: RequestInit): Promise<MembersContent> => {

  return customFetch<MembersContent>(getGetMembersContentUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetMembersContentQueryKey = (id: number,) => {
    return [
    `/api/members/content/${id}`
    ] as const;
    }


export const getGetMembersContentQueryOptions = <TData = Awaited<ReturnType<typeof getMembersContent>>, TError = ErrorType<void>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMembersContent>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMembersContentQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMembersContent>>> = ({ signal }) => getMembersContent(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMembersContent>>, TError, TData> & { queryKey: QueryKey }
}

export type GetMembersContentQueryResult = NonNullable<Awaited<ReturnType<typeof getMembersContent>>>
export type GetMembersContentQueryError = ErrorType<void>


/**
 * @summary Get a single content item
 */

export function useGetMembersContent<TData = Awaited<ReturnType<typeof getMembersContent>>, TError = ErrorType<void>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMembersContent>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetMembersContentQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getLikeMembersContentUrl = (id: number,) => {




  return `/api/members/content/${id}/like`
}

/**
 * @summary Like content — awards GLO reward to creator
 */
export const likeMembersContent = async (id: number, options?: RequestInit): Promise<LikeResult> => {

  return customFetch<LikeResult>(getLikeMembersContentUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}




export const getLikeMembersContentMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof likeMembersContent>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof likeMembersContent>>, TError,{id: number}, TContext> => {

const mutationKey = ['likeMembersContent'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof likeMembersContent>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  likeMembersContent(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type LikeMembersContentMutationResult = NonNullable<Awaited<ReturnType<typeof likeMembersContent>>>

    export type LikeMembersContentMutationError = ErrorType<unknown>

    /**
 * @summary Like content — awards GLO reward to creator
 */
export const useLikeMembersContent = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof likeMembersContent>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof likeMembersContent>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getLikeMembersContentMutationOptions(options));
    }

export const getListGasFeesUrl = (params?: ListGasFeesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/members/gas-fees?${stringifiedParams}` : `/api/members/gas-fees`
}

/**
 * @summary List GLO gas fee transactions
 */
export const listGasFees = async (params?: ListGasFeesParams, options?: RequestInit): Promise<GasFeeRecord[]> => {

  return customFetch<GasFeeRecord[]>(getListGasFeesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListGasFeesQueryKey = (params?: ListGasFeesParams,) => {
    return [
    `/api/members/gas-fees`, ...(params ? [params] : [])
    ] as const;
    }


export const getListGasFeesQueryOptions = <TData = Awaited<ReturnType<typeof listGasFees>>, TError = ErrorType<unknown>>(params?: ListGasFeesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listGasFees>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListGasFeesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listGasFees>>> = ({ signal }) => listGasFees(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listGasFees>>, TError, TData> & { queryKey: QueryKey }
}

export type ListGasFeesQueryResult = NonNullable<Awaited<ReturnType<typeof listGasFees>>>
export type ListGasFeesQueryError = ErrorType<unknown>


/**
 * @summary List GLO gas fee transactions
 */

export function useListGasFees<TData = Awaited<ReturnType<typeof listGasFees>>, TError = ErrorType<unknown>>(
 params?: ListGasFeesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listGasFees>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListGasFeesQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getGetMembersRatesUrl = () => {




  return `/api/members/rates`
}

/**
 * @summary Get current GLO/HALO gas fee and reward rates
 */
export const getMembersRates = async ( options?: RequestInit): Promise<MembersRates> => {

  return customFetch<MembersRates>(getGetMembersRatesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetMembersRatesQueryKey = () => {
    return [
    `/api/members/rates`
    ] as const;
    }


export const getGetMembersRatesQueryOptions = <TData = Awaited<ReturnType<typeof getMembersRates>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMembersRates>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMembersRatesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMembersRates>>> = ({ signal }) => getMembersRates({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMembersRates>>, TError, TData> & { queryKey: QueryKey }
}

export type GetMembersRatesQueryResult = NonNullable<Awaited<ReturnType<typeof getMembersRates>>>
export type GetMembersRatesQueryError = ErrorType<unknown>


/**
 * @summary Get current GLO/HALO gas fee and reward rates
 */

export function useGetMembersRates<TData = Awaited<ReturnType<typeof getMembersRates>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMembersRates>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetMembersRatesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getSyncFromOnlyMemberzUrl = () => {




  return `/api/members/om-sync`
}

/**
 * @summary Pull content and creator data from Only-Memberz API and sync to ISM library
 */
export const syncFromOnlyMemberz = async ( options?: RequestInit): Promise<OmSyncResult> => {

  return customFetch<OmSyncResult>(getSyncFromOnlyMemberzUrl(),
  {
    ...options,
    method: 'POST'


  }
);}




export const getSyncFromOnlyMemberzMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof syncFromOnlyMemberz>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof syncFromOnlyMemberz>>, TError,void, TContext> => {

const mutationKey = ['syncFromOnlyMemberz'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof syncFromOnlyMemberz>>, void> = () => {


          return  syncFromOnlyMemberz(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SyncFromOnlyMemberzMutationResult = NonNullable<Awaited<ReturnType<typeof syncFromOnlyMemberz>>>

    export type SyncFromOnlyMemberzMutationError = ErrorType<unknown>

    /**
 * @summary Pull content and creator data from Only-Memberz API and sync to ISM library
 */
export const useSyncFromOnlyMemberz = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof syncFromOnlyMemberz>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof syncFromOnlyMemberz>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getSyncFromOnlyMemberzMutationOptions(options));
    }

export const getGetOmSyncStatusUrl = () => {




  return `/api/members/om-sync/status`
}

/**
 * @summary Get last Only-Memberz sync status
 */
export const getOmSyncStatus = async ( options?: RequestInit): Promise<OmSyncResult> => {

  return customFetch<OmSyncResult>(getGetOmSyncStatusUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetOmSyncStatusQueryKey = () => {
    return [
    `/api/members/om-sync/status`
    ] as const;
    }


export const getGetOmSyncStatusQueryOptions = <TData = Awaited<ReturnType<typeof getOmSyncStatus>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getOmSyncStatus>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOmSyncStatusQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOmSyncStatus>>> = ({ signal }) => getOmSyncStatus({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOmSyncStatus>>, TError, TData> & { queryKey: QueryKey }
}

export type GetOmSyncStatusQueryResult = NonNullable<Awaited<ReturnType<typeof getOmSyncStatus>>>
export type GetOmSyncStatusQueryError = ErrorType<unknown>


/**
 * @summary Get last Only-Memberz sync status
 */

export function useGetOmSyncStatus<TData = Awaited<ReturnType<typeof getOmSyncStatus>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getOmSyncStatus>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetOmSyncStatusQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







